import { LocalStorage } from "./local-storage";

const NAME_OF_RECORD = "bm-expire-storage";

export class LocalStorageWithExpire {
	public static set(name: string, value: string, expireMin: number): void {
		const raw = LocalStorage.get(NAME_OF_RECORD) || "[]";
		let data: { name: string; value: string; expire: number }[] = [];

		try {
			data = JSON.parse(raw);
		} catch (e) {
			data = [];
		}

		data = data.filter((element) => element.expire > Date.now() && element.name !== name);
		data.push({
			name,
			value,
			expire: Date.now() + expireMin * 60 * 1000,
		});

		LocalStorage.set(NAME_OF_RECORD, JSON.stringify(data));
	}

	public static get(name: string): string {
		const raw = LocalStorage.get(NAME_OF_RECORD) || "[]";
		let data: { name: string; value: string; expire: number }[] = [];

		try {
			data = JSON.parse(raw);
		} catch (e) {
			data = [];
		}

		const item = data.find((element) => element.name === name);

		if (item && item.expire > Date.now()) {
			return item.value;
		}

		return "";
	}

	public static remove(name: string): void {
		const raw = LocalStorage.get(NAME_OF_RECORD) || "[]";
		let data: { name: string; value: string; expire: number }[] = [];

		try {
			data = JSON.parse(raw);
		} catch (e) {
			data = [];
		}

		data = data.filter((item) => item.expire > Date.now() && item.name !== name);

		LocalStorage.set(NAME_OF_RECORD, JSON.stringify(data));
	}
}
